// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"f36f9537","472":"eea8b5ca","863":"4e9b9b1b"}[chunkId] + ".chunk.js";
};